<template>
  <div class="container">
    <div class="school-body">
      <el-row>
        <el-col :span="24">
          <div class="classwrapper">
            <el-row>
              <el-col :span="24">
                <div>
                  <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item @click.native="$router.back()" class="breadcrumb-item-back">返回</el-breadcrumb-item>
                    <el-breadcrumb-item>课程详情</el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row class="topTxt">
        <el-col :span="18">
          <div>
            <el-row>
              <el-col :span="2">
                <div class="grid-content bg-purple">
                  <svg t="1650504274483" class="icon" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2166" width="40" height="40">
                    <path d="M513.634 137.13H35.092C16.284 137.13 0.92 152.384 0.92 171.186l-0.919 738.858c0 18.921 15.253 34.173 34.173 34.173h351.022l9.516 18.691c5.852 11.468 17.551 18.696 30.508 18.696H604.114c12.498 0 23.966-6.882 30.041-17.778l10.67-19.491h348.61c18.809 0 34.176-15.253 34.176-34.173V171.303c0-18.808-15.256-34.173-34.176-34.173H513.634z m0 0" fill="#2A95D4" p-id="2167" />
                    <path d="M521.09 134.376c-6.079 4.131-13.877 4.933-20.641 1.954-37.5-16.52-164.908-68.124-285.318-68.124H93.002c-11.697 0-21.216 9.521-21.216 21.216v764.43c0 11.697 9.519 21.217 21.216 21.217h376.483c6.191 0 12.043 2.637 16.053 7.335l10.096 11.585c8.371 9.631 23.277 9.749 31.765 0.342l11.238-12.269c4.01-4.474 9.743-6.993 15.706-6.993h377.059c11.697 0 21.211-9.52 21.211-21.217l1.033-764.43c0-11.808-9.517-21.328-21.217-21.328H803.653c0 0.113-178.44-4.701-282.563 66.282z m0 0" fill="#FFFFFF" p-id="2168" />
                    <path d="M513.288 942.498l-35.892-41.284c-4.017-4.703-9.861-7.341-16.054-7.341H72.476c-11.699 0-21.21-9.514-21.21-21.211V62.361c0-11.697 9.512-21.216 21.21-21.216h144.952c115.364 0 234.624 44.724 283.479 65.251 6.424 2.637 13.648 2.064 19.491-1.49 108.374-66.97 274.884-63.991 286.004-63.762h151.483c11.814 0 21.334 9.519 21.219 21.328l-1.15 810.301c0 11.697-9.511 21.216-21.211 21.216H566.845a21.124 21.124 0 0 0-15.712 6.994l-37.845 41.515z m-416.27-94.495h385.31c6.196 0 12.04 2.637 16.056 7.341 8.371 9.631 23.282 9.748 31.766 0.347l0.686-0.688a21.125 21.125 0 0 1 15.712-6.999H932.084l1.038-761.1h-127.75c-1.837 0-183.143-4.013-277.75 68.458l-0.798 0.58c-6.308 4.814-14.907 5.732-22.136 2.287l-0.915-0.458c-1.953-0.92-150.456-70.868-286.458-70.868H97.018v761.1z m0 0" fill="#8A8A8A" p-id="2169" />
                    <path d="M490.699 146.65h45.871v765.46h-45.871z" fill="#8A8A8A" p-id="2170" />
                    <path d="M587.826 251.576h293.574v45.871H587.826v-45.871z m0 173.733h293.574v45.871H587.826v-45.871z m0 193.113h293.574v45.87H587.826v-45.87zM146.325 251.459h293.571v45.87H146.325v-45.87z m0 173.85h293.571v45.871H146.325v-45.871z m0 193.113h293.571v45.87H146.325v-45.87z m0 0" fill="#CDCDCD" p-id="2171" />
                  </svg>
                </div>
              </el-col>
              <el-col :span="22">
                <div style="line-height: 40px">
                  <span class="text_title">
                    第{{ this.$route.query.index }}讲
                    {{ stuInfo.lessionInfo.title }}
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="margin_top">
            <span style="margin-right: 10px; font-weight: bold">课程简介:</span>
            {{ stuInfo.lessionInfo.desc }}
          </div>
          <div class="margin_top">
            <span style="margin-right: 10px; font-weight: bold">
              <span v-if="stuInfo.stuTchPlanInfo.xm_miss_state == 4">补课时间:</span>
              <span v-else>上课时间:</span>
            </span>
            <span v-if="stuInfo.stuTchPlanInfo.xm_miss_state == 4">{{ stuTchPlanInfo.techPlanInfo.start_class_date }} -
              {{
                stuTchPlanInfo.techPlanInfo.end_class_date.slice(10, 20)
              }}</span>
            <span v-else>{{ stuInfo.start_class_date }} -
              {{ stuInfo.end_class_date.slice(10, 20) }}</span>
            <!-- {{ stuInfo.start_class_date }} - {{ stuInfo.end_class_date.slice(10, 20) }} -->
          </div>
          <div class="margin_top">
            <span style="margin-right: 10px; font-weight: bold">上课教师:</span>
            {{ stuInfo.lecturerName }}
          </div>
          <div v-if="isReloadData" class="operation">
            <div class="operation-box">
              <!-- 知识点海报 -->
              <div class="operation-item poster" v-if="
                  LessonInfoFor.other_meterial_url ||
                    LessonInfoFor.knowledge_point_url
                " :disabled="
                  LessonInfoFor.other_meterial_url === '' ||
                    (LessonInfoFor.other_meterial_url === null &&
                      LessonInfoFor.knowledge_point_url === null) ||
                    LessonInfoFor.knowledge_point_url === ''
                " @click="DownloadFile">
                <img src="@/assets/image/stuUI/stuDetailIcon1@2x.png" alt="" />
                <span>知识点海报</span>
              </div>
              <!-- 学生讲义 stu_note_auth 学生讲义的开启权限由userInfo里的stuNoteAuth控制 -->
              <div class="operation-item handouts" v-if="$store.state.user.userInfo.stuNoteAuth" :disabled="isDisabled" @click="LookNote">
                <img src="@/assets/image/stuUI/stuDetailIcon2@2x.png" alt="" />
                <span>学生讲义</span>
              </div>
              <!-- 组装手册 -->
              <div class="operation-item manual" v-if="LessonInfoFor.assemble_pitcure || LessonInfoFor.assemble_pitcure_pdf" @click="assemblySteps">
                <img src="@/assets/image/stuUI/stuDetailIcon3@2x.png" alt="" />
                <span>组装手册</span>
              </div>
              <!-- 课堂实录 -->
              <div class="operation-item video" v-if="LessonInfoFor.video_url" :disabled="
                  LessonInfoFor.video_url === '' ||
                    LessonInfoFor.video_url === null
                " @click="Downloadvideo">
                <img src="@/assets/image/stuUI/stuDetailIcon4@2x.png" alt="" />
                <span>课堂实录</span>
              </div>
              <!-- 学习报告 -->
              <div class="operation-item report" @click="lookStuReoprt" v-if="evaluateForStuList && evaluateForStuList.join('')!==''">
                <img src="@/assets/image/stuUI/stuDetailIcon5@2x.png" alt="" style="width:40px" />
                <span style="padding-top:10px">学习报告</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div v-if="isShow3">
        <el-card shadow="hover" style="margin-right: 20px; margin-top: 20px;border:none;background-color:#F9F9FB;border-radius:10px;" v-if="stuTchPlanInfo.subject_id === 4">
          <div class="stuWorks">
            <el-row :gutter="40">
              <el-col :span="4">
                <div style="
                  text-align: right;
                  padding: 5px;
                  border: 1px solid #f0f0f0;
                  border-radius: 5px;
                ">
                  <div>
                    <el-image src="https://wugecdn.steam.fun/resources/static/images/C-LOGO.png" fit="fill"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="14" class="text_center">
                <div style="
                  color: 333333;
                  font-weight: bold;
                  font-size: 14px;
                  margin-top: 5px;
                ">
                  老师评语:
                </div>
                <div class="topSpacing">
                  <span v-if="stuTchPlanInfo.classWorkState === true">
                    <span v-if="stuTchPlanInfo.classWorkInfo.work_type === 1">
                      <span v-if="stuTchPlanInfo.classWorkInfo.remark === ''">暂无评语</span>
                      <span v-else>
                        {{ stuTchPlanInfo.classWorkInfo.remark }}
                      </span>
                    </span>
                  </span>
                  <span v-else>
                    <span>暂无评语</span>
                  </span>
                </div>

                <div class="topSpacing">
                  <span style="color: 333333; font-weight: bold; font-size: 14px">作品星级:</span>
                  <br />
                  <div style="margin-top: 10px">
                    <div style="display: inline-block" v-if="stuTchPlanInfo.classWorkState === true">
                      <span v-if="stuTchPlanInfo.classWorkInfo.work_type === 1">
                        <span v-if="stuTchPlanInfo.classWorkInfo.markpoint === null">暂无星级</span>
                        <el-rate v-else v-model="stuTchPlanInfo.classWorkInfo.markpoint" disabled></el-rate>
                      </span>
                    </div>
                    <div style="display: inline-block;" v-else>暂无星级</div>
                  </div>
                </div>
              </el-col>

              <el-col :span="6">
                <el-button style=" margin-left: 50px; margin-top: 40px" round class="class_btn" type="primary" :disabled="isDisabled1" @click="classCreation">上课创作</el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>

      <el-card shadow="hover" style="margin-right: 20px; margin-top: 20px;border:none;background-color:#F9F9FB;border-radius:10px;" v-else>
        <div class="stuWorks">
          <el-row :gutter="40">
            <el-col :span="4">
              <div style="
                  text-align: right;
                  padding: 5px;
                  border: 1px solid #f0f0f0;
                  border-radius: 5px;
                ">
                <div v-if="stuTchPlanInfo.classWorkState === true">
                  <el-image v-if="stuTchPlanInfo.classWorkInfo.work_type === 1" :src="stuTchPlanInfo.classWorkInfo.covers" fit="fill"></el-image>
                </div>
                <div v-else>
                  <el-image :src="LessonInfoFor.img_url" fit="fill"></el-image>
                </div>

                <div v-if="ishomework1">
                  <div style="line-height: 20px" v-if="stuTchPlanInfo.subject_id === 2">
                    <span style="vertical-align: middle">分享</span>
                    <span>
                      <svg style="
                          vertical-align: middle;
                          margin-left: 5px;
                          margin-right: 5px;
                          cursor: pointer;
                        " t="1650510142468" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6870" width="20" height="20" @click="CreatBill('1')">
                        <path d="M511 64C263.5 64 63 264.5 63 512c0 247.4 200.6 448 448 448s448-200.6 448-448c0-247.5-200.6-448-448-448z m-66.8 448c0 10.2-2.1 20-5.8 28.9L561.6 623c12-8.5 26.7-13.5 42.5-13.5 40.9 0 74.1 33.2 74.1 74.1 0 40.9-33.2 74.1-74.1 74.1-40.9 0-74.1-33.2-74.1-74.1 0-5.7 0.7-11.2 1.9-16.6l-131.4-87.6c-9.3 4.2-19.6 6.6-30.5 6.6-40.9 0-74.1-33.2-74.1-74.1 0-40.9 33.2-74.1 74.1-74.1 10.9 0 21.2 2.4 30.5 6.6l131.4-87.6c-1.2-5.3-1.9-10.9-1.9-16.6 0-40.9 33.2-74.1 74.1-74.1 40.9 0 74.1 33.2 74.1 74.1s-33.2 74.1-74.1 74.1c-15.8 0-30.5-5-42.5-13.5l-123.2 82.1c3.7 9.1 5.8 18.8 5.8 29.1z" p-id="6871" fill="#1296db" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="14" class="text_center">
              <div style="
                  color: 333333;
                  font-weight: bold;
                  font-size: 14px;
                  margin-top: 5px;
                ">
                老师评语:
              </div>
              <div class="topSpacing">
                <span v-if="stuTchPlanInfo.classWorkState === true">
                  <span v-if="stuTchPlanInfo.classWorkInfo.work_type === 1">
                    <span v-if="stuTchPlanInfo.classWorkInfo.remark === ''">暂无评语</span>
                    <span v-else>
                      {{ stuTchPlanInfo.classWorkInfo.remark }}
                    </span>
                  </span>
                </span>
                <span v-else>
                  <span>暂无评语</span>
                </span>
              </div>

              <div class="topSpacing">
                <span style="color: 333333; font-weight: bold; font-size: 14px">作品星级:</span>
                <br />
                <div style="margin-top: 10px">
                  <div style="display: inline-block" v-if="stuTchPlanInfo.classWorkState === true">
                    <span v-if="stuTchPlanInfo.classWorkInfo.work_type === 1">
                      <span v-if="stuTchPlanInfo.classWorkInfo.markpoint === null">暂无星级</span>
                      <el-rate v-else v-model="stuTchPlanInfo.classWorkInfo.markpoint" disabled></el-rate>
                    </span>
                  </div>
                  <div style="display: inline-block" v-else>暂无星级</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="classlist-btn" v-if="isReloadData">
                <span>
                  <el-button v-if="!stuTchPlanInfo.classWorkState" style=" margin-left: 50px; margin-top: 40px" round :disabled="isDisabled1" class="class_btn" type="primary" @click="CreateWork(stuTchPlanInfo.id, '1')">上课创作</el-button>

                  <el-dropdown class="drop_btn" v-if="stuTchPlanInfo.classWorkState">
                    <el-button type="primary" style=" margin-left: 50px; margin-top: 40px" round :disabled="isDisabled1">上课创作</el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="CreateWork(stuTchPlanInfo.id, '1')">重新挑战</el-dropdown-item>
                      <el-dropdown-item @click.native="CreateWork(stuTchPlanInfo.id, '2')">继续挑战</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <div v-if="isShow4">
        <div v-if="stuTchPlanInfo.subject_id === 4">
          <el-card style="margin-top: 20px; margin-right: 20px;border:none;background-color:#F9F9FB;border-radius:10px;" shadow="hover">
            <div class="stuWorks">
              <el-row :gutter="40" class="text_center">
                <el-col :span="4">
                  <div style="
                  text-align: right;
                  padding: 5px;
                  border: 1px solid #f0f0f0;
                  border-radius: 5px;
                ">
                    <div>
                      <el-image src="https://wugecdn.steam.fun/resources/static/images/C-LOGO.png" fit="fill">
                      </el-image>
                    </div>
                  </div>
                </el-col>
                <el-col :span="14">
                  <div style="margin-top: 5px">
                    <span style="color: 333333; font-weight: bold; font-size: 14px">老师评语:</span>
                  </div>
                  <div class="topSpacing">
                    <span v-if="stuTchPlanInfo.homeWorkState === true">
                      <span v-if="stuTchPlanInfo.homeWorkInfo.work_type === 2">
                        <span v-if="stuTchPlanInfo.homeWorkInfo.remark === ''">暂无评语</span>
                        <span v-else>{{
                          stuTchPlanInfo.homeWorkInfo.remark
                        }}</span>
                      </span>
                    </span>
                    <span v-else>
                      <span>暂无评语</span>
                    </span>
                  </div>
                  <div class="topSpacing">
                    <span style="color: 333333; font-weight: bold; font-size: 14px">作品星级:</span>
                    <br />
                    <div style="display: inline-block; margin-top: 10px">
                      <div style="display: inline-block; margin-top: 10px" v-if="stuTchPlanInfo.homeWorkState === true">
                        <span v-if="stuTchPlanInfo.homeWorkInfo.work_type === 2">
                          <span v-if="
                              stuTchPlanInfo.homeWorkInfo.markpoint === null
                            ">暂无星级</span>
                          <el-rate v-else v-model="stuTchPlanInfo.homeWorkInfo.markpoint" disabled></el-rate>
                        </span>
                      </div>

                      <div style="display: inline-block" v-else>暂无星级</div>
                    </div>
                  </div>
                </el-col>

                <el-col :span="6" v-if="stuTchPlanInfo.subject_id === 4">
                  <el-button style=" margin-left: 50px; margin-top: 40px" round class="class_btn" type="primary" :disabled="isDisabled1" @click="classCreation1">课后挑战</el-button>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
      </div>
      <div v-else>
        <el-card style="margin-top: 20px; margin-right: 20px;border:none;background-color:#F9F9FB;border-radius:10px;" shadow="hover" v-if="this.ishomework">
          <div class="stuWorks">
            <el-row :gutter="40" class="text_center">
              <el-col :span="4">
                <div style="
                  text-align: right;
                  padding: 5px;
                  border: 1px solid #f0f0f0;
                  border-radius: 5px;
                ">
                  <div v-if="stuTchPlanInfo.homeWorkState === true">
                    <el-image v-if="stuTchPlanInfo.homeWorkInfo.work_type === 2" :src="stuTchPlanInfo.homeWorkInfo.covers" fit="fill"></el-image>
                  </div>
                  <div v-else>
                    <el-image :src="LessonInfoFor.img_url" fit="fill"></el-image>
                  </div>
                  <div v-if="ishomework2">
                    <div style="line-height: 20px" v-if="stuTchPlanInfo.subject_id === 2">
                      <span style="vertical-align: middle">分享</span>
                      <svg style="
                        vertical-align: middle;
                        margin-left: 5px;
                        margin-right: 5px;
                        cursor: pointer;
                      " t="1650510142468" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6870" width="20" height="20" @click="CreatBill('2')">
                        <path d="M511 64C263.5 64 63 264.5 63 512c0 247.4 200.6 448 448 448s448-200.6 448-448c0-247.5-200.6-448-448-448z m-66.8 448c0 10.2-2.1 20-5.8 28.9L561.6 623c12-8.5 26.7-13.5 42.5-13.5 40.9 0 74.1 33.2 74.1 74.1 0 40.9-33.2 74.1-74.1 74.1-40.9 0-74.1-33.2-74.1-74.1 0-5.7 0.7-11.2 1.9-16.6l-131.4-87.6c-9.3 4.2-19.6 6.6-30.5 6.6-40.9 0-74.1-33.2-74.1-74.1 0-40.9 33.2-74.1 74.1-74.1 10.9 0 21.2 2.4 30.5 6.6l131.4-87.6c-1.2-5.3-1.9-10.9-1.9-16.6 0-40.9 33.2-74.1 74.1-74.1 40.9 0 74.1 33.2 74.1 74.1s-33.2 74.1-74.1 74.1c-15.8 0-30.5-5-42.5-13.5l-123.2 82.1c3.7 9.1 5.8 18.8 5.8 29.1z" p-id="6871" fill="#1296db" />
                      </svg>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="14">
                <div style="margin-top: 5px">
                  <span style="color: 333333; font-weight: bold; font-size: 14px">老师评语:</span>
                </div>
                <div class="topSpacing">
                  <span v-if="stuTchPlanInfo.homeWorkState === true">
                    <span v-if="stuTchPlanInfo.homeWorkInfo.work_type === 2">
                      <span v-if="stuTchPlanInfo.homeWorkInfo.remark === ''">暂无评语</span>
                      <span v-else>{{
                        stuTchPlanInfo.homeWorkInfo.remark
                      }}</span>
                    </span>
                  </span>
                  <span v-else>
                    <span>暂无评语</span>
                  </span>
                </div>
                <div class="topSpacing">
                  <span style="color: 333333; font-weight: bold; font-size: 14px">作品星级:</span>
                  <br />
                  <div style="display: inline-block; margin-top: 10px">
                    <div style="display: inline-block; margin-top: 10px" v-if="stuTchPlanInfo.homeWorkState === true">
                      <span v-if="stuTchPlanInfo.homeWorkInfo.work_type === 2">
                        <span v-if="stuTchPlanInfo.homeWorkInfo.markpoint === null">暂无星级</span>
                        <el-rate v-else v-model="stuTchPlanInfo.homeWorkInfo.markpoint" disabled></el-rate>
                      </span>
                    </div>

                    <div style="display: inline-block" v-else>暂无星级</div>
                  </div>
                </div>
              </el-col>

              <el-col :span="6" v-if="stuTchPlanInfo.subject_id === 4">
                <el-button style=" margin-left: 50px; margin-top: 40px" round class="class_btn" type="primary">课后挑战1</el-button>
              </el-col>
              <el-col :span="6" v-else>
                <div class="classlist-btn" v-if="isReloadData">
                  <span>
                    <el-button style=" margin-left: 50px; margin-top: 40px" round v-if="!stuTchPlanInfo.homeWorkState" :disabled="isDisabled1" class="class_btn" type="primary" @click="CreateWork(stuTchPlanInfo.id, '3')">课后挑战</el-button>

                    <el-dropdown class="drop_btn" v-if="stuTchPlanInfo.homeWorkState">
                      <el-button type="primary" style=" margin-left: 50px; margin-top: 40px" round :disabled="isDisabled1">课后作业</el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="CreateWork(stuTchPlanInfo.id, '3')">重新挑战</el-dropdown-item>
                        <el-dropdown-item @click.native="CreateWork(stuTchPlanInfo.id, '4')">继续挑战</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
    </div>

    <el-dialog title="作品海报" :visible.sync="dialogVisible2" width="500px" top="5vh">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <el-image id="myCanvas" :src="posterImg" fit="fill"></el-image>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-form size="mini" ref="form" :model="form_share" label-position="top">
              <el-form-item label="样式">
                <el-select style="width: 100px" v-model="form_share.type" placeholder="选择样式" @change="ChangeShareType">
                  <el-option label="样式一" value="1"></el-option>
                  <el-option label="样式二" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="颜色">
                <el-select style="width: 100px" v-model="form_share.color" placeholder="选择颜色" @change="ChangeShareColor">
                  <el-option label="蓝色" value="1"></el-option>
                  <el-option label="绿色" value="2"></el-option>
                  <el-option label="品红" value="3"></el-option>
                  <el-option label="红色" value="4"></el-option>
                  <el-option label="黄色" value="5"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="CreateShareImg" :loading="share_loading">生成海报</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <div id="posterHtml" v-show="false" :style="{
        backgroundImage: 'url(' + share_img + ')',
        position: 'absolute',
        top: '0px',
        width: '1242px',
        height: '2208px',
      }">
      <div style="position: relative; top: 740px; text-align: center">
        <span style="font-weight: bold; color: white; font-size: 80px">
          {{ form_share.title }}
        </span>
        <br />
        <span style="color: white; font-size: 50px">
          {{ "作者:" + form_share.name }}
        </span>
      </div>

      <el-image style="margin-top: 765px; left: 180px; width: 902px; height: 665px" :src="form_share.cover" fit="fill">
      </el-image>

      <div id="qrcodeWorkImg" style="margin-left: 780px; margin-top: 108px"></div>
    </div>
    <div id="posterHtml1" v-show="false" :style="{
        backgroundImage: 'url(' + share_img + ')',
        position: 'absolute',
        top: '0px',
        width: '1242px',
        height: '2208px',
      }">
      <el-image style="margin-top: 618px; left: 122px; width: 1004px; height: 753px" :src="form_share.cover" fit="fill">
      </el-image>

      <div style="position: relative; top: 10px; text-align: center">
        <span style="font-weight: bold; color: #333333; font-size: 60px">
          {{ form_share.title }}
        </span>
        <br />
        <span style="color: #333333; font-size: 40px">
          {{ "作者:" + form_share.name }}
        </span>
      </div>

      <div style="margin-left: 230px; margin-top: 33px; color: #f7ba2a">
        <i v-for="count in form_share.star_num" :key="count" class="el-icon-star-on" style="font-size: 100px; margin: 10px"></i>
      </div>

      <div v-if="form_share.star_num" id="qrcodeWorkImg1" style="margin-left: 135px; margin-top: 212px"></div>
      <div v-else id="qrcodeWorkImg1" style="margin-left: 135px; margin-top: 365px"></div>
    </div>
    <el-drawer title="组装步骤" :visible.sync="dialogVisible5" size="85%" direction="ltr">
      <div style="height: 100vh; overflow-y: scroll" v-if="curriculumRow.assemble_pitcure_state === 1">
        <mavon-editor v-model="curriculumRow.assemble_pitcure" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
      </div>
      <div v-else-if="curriculumRow.assemble_pitcure_state === 2">
        <iframe :src="curriculumRow.assemble_pitcure_pdf" frameborder="0" style="width: 100%; height: 100vh; margin: auto; display: block"></iframe>
      </div>
    </el-drawer>

    <el-drawer :with-header="false" class="student_sign" title="学生讲义" size="85%" :visible.sync="dialogVisible1" direction="ltr" :destroy-on-close="true">
      <div>
        <iframe style="width: 100%; height: 100vh" :src="stu_note_url"></iframe>
      </div>
    </el-drawer>

    <!-- 课堂点评 抽屉 -->
    <el-drawer :with-header="false" title="课堂点评" size="600px" :visible.sync="ckassRevuewDrawerShow" direction="rtl" :destroy-on-close="true">
      <el-empty v-if="evaluateForStuList.length == 0" description="暂无评论"></el-empty>
      <div class="eval-box" v-else>
        <div class="iframe-box" :key="evaIndex">
          <iframe :src="`${learningReportBaseUrl}/learningReport/index.html?stuTchPlanEvaId=${evaluateForStuList[evaIndex].id}&eduId=${evaluateForStuList[evaIndex].educational_institution_id}&eduCampusId=${evaluateForStuList[evaIndex].educational_institution_campus_id}&tchPlanId=${evaluateForStuList[evaIndex].teaching_plan_id}&stuTchPlanId=${evaluateForStuList[evaIndex].stu_tch_plan_id}&plat=PC`" frameborder="0" width="100%" height="100%"></iframe>
        </div>
        <ul class="pagination">
          <li v-for="(item,index) in evaluateForStuList" :key="item.id" :class="{active: evaIndex === index}" @click="()=>evaIndex=index">
            {{index+1}}
            <!-- <div class="eval-top">
            <strong>{{stuInfo.lessionInfo.title}}</strong>
            <span>{{item.created_time}}</span>
            <el-link type="primary" icon="el-icon-thumb" style="margin-left:auto" @click="handleLookReport(item)">查看学习报告</el-link>
          </div>
          <div class="eval-title">
            <img src="https://wugecdn.steam.fun/resources/static/jiaxiaotong/%E8%80%81%E5%B8%88%E8%AF%84%E8%AF%AD.png" alt="Icon" /> 教师评语
          </div>
          <div class="eval-content" :title="item.remark">
            <p>
              {{item.remark}}
            </p>
          </div> -->
          </li>
        </ul>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2"; // 引入qrcode
import {
  stuSignInForClass,
  stuGetTchWorkListByStuTchPlanId,
  saveCppTchWork,
  stuGetStuCppLessonOjProblemList,
  getLessonInfoForStuSys,
  getEvaluateForStu,
} from "@/api/educational";
import moment from "moment";
import Axios from "axios";

export default {
  data() {
    return {
      learningReportBaseUrl: process.env.VUE_APP_BASE_URL,
      ckassRevuewDrawerShow: false,
      evaluateForStuList: [],
      evaIndex: 0,
      LessonInfoFor: {},
      isDisabled1: false,

      isDisabled: false,
      isShow3: false,
      isShow4: false,
      curriculumRow: {
        assemble_pitcure: "",
      },
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true, // 预览
      },
      ishomework2: false,
      ishomework: true,
      ishomework1: false,
      isbtn1: false,

      isbtn: false,
      isReloadData: true,
      dialogVisible1: false,
      isShow: true,
      isShow1: false,
      //生成海报
      posterContent: "很不错", // 文案内容
      posterHtmlBg:
        "https://wugecdn.steam.fun/courses/b_scratch_course/bb_general_course/version2.0/poster/09%E5%B0%8F%E5%BF%83%E9%9B%AA%E5%B4%A9.png",
      posterImg: "", // 最终生成的海报图片

      share_img: "", //默认海报
      share_type: "1", //海报类型

      form_share: {
        work_id: "",
        type: "1",
        color: "1",
        cover: "",
        title: "",
        name: "",
        star_num: 0,
        images1: [
          "https://wugecdn.steam.fun/resources/static/work_share/bg_blue_1.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_green_1.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_pink_1.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_red_1.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_1.png",
        ],
        images2: [
          "https://wugecdn.steam.fun/resources/static/work_share/bg_blue_2.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_green_2.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_pink_2.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_red_2.png",
          "https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_2.png",
        ],
      },
      share_loading: false, //生成海报加载

      activeName: "first",
      dialogVisible2: false,
      dialogVisible5: false,
      stu_note_url: "",
      stuInfo: {},
      stuInfo1: {},
      stuTchPlanInfo: {},
      workList: [],
    };
  },
  watch() {
    var elevideo = document.getElementById("video");
    elevideo.addEventListener("loadedmetadata", function () {
      //加载数据
      //视频的总长度
      console.log(elevideo.duration, "视频的总长度");
    });
  },
  created() {
    this.$forceUpdate();

    this.stuInfo = JSON.parse(sessionStorage.getItem("stuMsg1"));
    console.log(this.stuInfo, 789456456);

    this.stuInfo1 = JSON.parse(
      sessionStorage.getItem("stuMsg1")
    ).stuTchPlanInfo;
  },
  mounted() {
    this.stuGetTchWorkListByStuTchPlanId();

    console.log("信息");
    console.log(this.stuInfo, 789453);
    // this.stuGetStuCppLessonOjProblemList()
    // this.stuGetStuCppLessonOjProblemList1()
    this.getLessonInfoForStuSys();
    this.methodGetEvaluateForStu();
  },
  methods: {
    //加载远程的Py代码
    ReadPyCode(url, callback) {
      Axios({
        method: "get",
        url: url,
        responseType: "text",
      }).then((res) => {
        callback(res.data);
      });
    },
    // 获取课堂评论列表
    methodGetEvaluateForStu() {
      getEvaluateForStu({ stu_tch_plan_id: this.stuInfo.stuTchPlanInfo.id }).then(res => {
        this.evaluateForStuList = res.evaluateList;
      })
    },
    //
    getLessonInfoForStuSys() {
      getLessonInfoForStuSys({
        lessonId: JSON.parse(sessionStorage.getItem("stuMsg1"))
          .curriculum_meterial_id,
      }).then((res) => {
        console.log(res, 123456);
        this.LessonInfoFor = res.lessonInfo;
        console.log(this.LessonInfoFor.home_template_url, 6666);
        if (this.LessonInfoFor.home_template_url === "") {
          this.ishomework = false;
        } else {
          this.ishomework = true;
        }
        if (this.LessonInfoFor.subject_id === 4) {
          this.stuGetStuCppLessonOjProblemList();
          this.stuGetStuCppLessonOjProblemList1();
        }
      });
    },
    //获取上课创作列表
    stuGetStuCppLessonOjProblemList() {
      stuGetStuCppLessonOjProblemList({
        lesson_id: JSON.parse(sessionStorage.getItem("stuMsg1"))
          .curriculum_meterial_id,
        type: 1,
      }).then((res) => {
        if (res.cppLessonOjProblemRelationList.length === 0) {
          this.isShow3 = false;
        } else {
          this.isShow3 = true;
        }
      });
    },
    stuGetStuCppLessonOjProblemList1() {
      stuGetStuCppLessonOjProblemList({
        lesson_id: JSON.parse(sessionStorage.getItem("stuMsg1"))
          .curriculum_meterial_id,
        type: 2,
      }).then((res) => {
        if (res.cppLessonOjProblemRelationList.length === 0) {
          this.isShow4 = false;
        } else {
          this.isShow4 = true;
        }
      });
    },

    //上课创作
    classCreation() {
      saveCppTchWork({
        stu_user_id: this.stuTchPlanInfo.student_user_id,
        stu_tch_plan_id: this.stuTchPlanInfo.id,
        covers: "https://wugecdn.steam.fun/resources/static/images/C-LOGO.png",
        title: this.stuInfo.lessionInfo.title,
        work_type: 1,
      }).then(() => {
        this.cpp_url =
          "/cpp/stu?" +
          "&lesson_id=" +
          JSON.parse(sessionStorage.getItem("stuMsg1")).curriculum_meterial_id +
          "&type=" +
          "1" +
          "&plan_id=" +
          this.stuTchPlanInfo.id;

        sessionStorage.setItem("lecturesTitle", this.stuInfo.lessionInfo.title);
        sessionStorage.setItem("sbj", "4");
        // window.open(this.cpp_url, "_blank");
        location.href = this.cpp_url;
      });
    },
    //课后练习
    classCreation1() {
      saveCppTchWork({
        stu_user_id: this.stuTchPlanInfo.student_user_id,
        stu_tch_plan_id: this.stuTchPlanInfo.id,
        covers: "https://wugecdn.steam.fun/resources/static/images/C-LOGO.png",
        title: this.stuInfo.lessionInfo.title,
        work_type: 2,
      }).then(() => {
        this.cpp_url =
          "/cpp/stu?" +
          "&lesson_id=" +
          JSON.parse(sessionStorage.getItem("stuMsg1")).curriculum_meterial_id +
          "&type=" +
          "2" +
          "&plan_id=" +
          this.stuTchPlanInfo.id;
        sessionStorage.setItem("lecturesTitle", this.stuInfo.lessionInfo.title);
        sessionStorage.setItem("sbj", "4");

        // window.open(this.cpp_url, "_blank");
        location.href = this.cpp_url
      });
    },
    assemblySteps() {
      this.curriculumRow = this.LessonInfoFor;
      this.dialogVisible5 = true;
    },
    Downloadvideo() {
      console.log("下载附加资料");

      console.log(this.stuInfo.lessionInfo);
      if (this.LessonInfoFor.educational_institution_id === null) {
        window.open(this.LessonInfoFor.video_url, "_blank");
      } else {
        let video = [];
        video = JSON.parse(this.LessonInfoFor.video_url);
        video.map((item) => {
          let routeData = this.$router.resolve({
            name: "video",
            query: {
              url: item.url,
              length: item.length,
              id: this.LessonInfoFor.id,
            },
          });
          window.open(routeData.href, "_blank");
        });
      }
    },
    DownloadFile() {
      console.log("下载附加资料");

      if (this.LessonInfoFor.educational_institution_id === null) {
        window.open(this.LessonInfoFor.other_meterial_url, "_blank");
      } else {
        let other_meterial_url1 = [];
        other_meterial_url1 = JSON.parse(
          this.LessonInfoFor.knowledge_point_url
        );
        console.log(other_meterial_url1);
        other_meterial_url1.map((item) => {
          let url1 = item.url;
          let url2 = url1.replace(
            "steamfun.oss-cn-zhangjiakou.aliyuncs.com",
            "wuge.steam.fun"
          );

          console.log(url2);

          window.open(url2);
        });
      }
    },
    lookStuReoprt() {
      this.ckassRevuewDrawerShow = true;
    },
    handleLookReport(item) {
      const reportUrl = `${process.env.VUE_APP_BASE_URL}/learningReport/index.html?stuTchPlanEvaId=${item.id}&eduId=${item.educational_institution_id}&eduCampusId=${item.educational_institution_campus_id}&tchPlanId=${item.teaching_plan_id}&stuTchPlanId=${item.stu_tch_plan_id}&plat=PC`
      window.open(reportUrl, "_blank");
    },
    stuGetTchWorkListByStuTchPlanId() {
      let stu_tch_plan_id1 = "";
      if (this.stuInfo.stuTchPlanInfo.xm_miss_state == 4) {
        stu_tch_plan_id1 = this.stuInfo.stuTchPlanInfo
          .xm_miss_to_stu_tch_plan_id;
      } else {
        stu_tch_plan_id1 = this.stuInfo.stuTchPlanInfo.id;
      }
      stuGetTchWorkListByStuTchPlanId({
        stu_tch_plan_id: stu_tch_plan_id1,
        // subject_code: this.stuInfo.subject_id
      }).then((res) => {
        console.log(res, 5555);
        // isDisabled1
        if (res.stuTchPlanInfo.sign_state != 1) {
          this.isDisabled1 = true;
          if (res.stuTchPlanInfo.xm_miss_state == 3) {
            this.isDisabled1 = false;
          }
        } else {
          this.isDisabled1 = false;
        }
        this.stuTchPlanInfo = res.stuTchPlanInfo;
        this.workList = res.workList;
        const startDate = moment().format("YYYY-MM-DD HH:mm:ss");
        console.log(this.stuTchPlanInfo, 12341564);
        console.log(this.stuInfo, 12341564);

        if (this.stuInfo.stuTchPlanInfo.xm_miss_state != 4) {
          if (
            this.LessonInfoFor.stu_note_url === "" ||
            this.stuInfo.sign_state != 1 ||
            moment(startDate).diff(moment(this.stuInfo.end_class_date)) < 0
          ) {
            this.isDisabled = true;
          } else {
            if (this.$store.state.user.userInfo.stuNoteAuth == false) {
              this.isDisabled = true;
            } else {
              this.isDisabled = false;
            }
          }
        } else {
          if (
            this.LessonInfoFor.stu_note_url === "" ||
            this.stuInfo.sign_state != 1 ||
            moment(startDate).diff(
              moment(this.stuTchPlanInfo.techPlanInfo.end_class_date)
            ) < 0
          ) {
            this.isDisabled = true;
          } else {
            if (this.$store.state.user.userInfo.stuNoteAuth == false) {
              this.isDisabled = true;
            } else {
              this.isDisabled = false;
            }
          }
        }

        if (this.stuTchPlanInfo.classWorkState === true) {
          this.ishomework1 = true;
        }
        if (this.stuTchPlanInfo.classWorkState === false) {
          this.ishomework1 = false;
        }
        if (this.stuTchPlanInfo.homeWorkState === true) {
          this.ishomework2 = true;
        }
        if (this.stuTchPlanInfo.homeWorkState === false) {
          this.ishomework2 = false;
        }
        console.log(this.workList);
      });
    },

    LookCode() {
      console.log("跳转到作品源码页面");
      let routeData = this.$router.resolve({
        path: "/scratch/show.html",
        query: { work_type: "2", work_id: this.stuInfo.id, subject_code: "2" },
      });
      window.open(routeData.href, "_blank");
    },
    CreateShareImg() {
      this.share_loading = true;

      // 生成海报
      const vm = this;

      if (this.form_share.type == "1") {
        const domObj = document.getElementById("posterHtml");
        console.log("分享海报-样式一");
        console.log(domObj);
        html2canvas(domObj, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          onclone(doc) {
            let e = doc.querySelector("#posterHtml");
            e.style.display = "block";
          },
        }).then(function (canvas) {
          // 在微信里,可长按保存或转发
          vm.posterImg = canvas.toDataURL("image/png");
          console.log("生成的海报");
          console.log(canvas);
          console.log(vm.posterImg);
          vm.share_loading = false;
          vm.$confirm("海报已生成,是否下载?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success",
          }).then(() => {
            vm.DownloadImage();
          });
        });
      } else if (this.form_share.type == "2") {
        const domObj = document.getElementById("posterHtml1");
        console.log("分享海报-样式二");
        console.log(domObj);
        html2canvas(domObj, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          onclone(doc) {
            let e = doc.querySelector("#posterHtml1");
            e.style.display = "block";
          },
        }).then(function (canvas) {
          // 在微信里,可长按保存或转发
          vm.posterImg = canvas.toDataURL("image/png");
          console.log("生成的海报");
          console.log(canvas);
          console.log(vm.posterImg);
          vm.share_loading = false;
          vm.$confirm("海报已生成,是否下载?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success",
          }).then(() => {
            vm.DownloadImage();
          });
        });
      }
    },

    ChangeShareType() {
      console.log("更换海报样式");
      console.log(this.form_share.type);
      if (this.form_share.type == "1") {
        if (this.form_share.color == "1") {
          this.posterImg = this.form_share.images1[0];
        } else if (this.form_share.color == "2") {
          this.posterImg = this.form_share.images1[1];
        } else if (this.form_share.color == "3") {
          this.posterImg = this.form_share.images1[2];
        } else if (this.form_share.color == "4") {
          this.posterImg = this.form_share.images1[3];
        } else if (this.form_share.color == "5") {
          this.posterImg = this.form_share.images1[4];
        }
        this.qrcode_work();
      } else if (this.form_share.type == "2") {
        if (this.form_share.color == "1") {
          this.posterImg = this.form_share.images2[0];
        } else if (this.form_share.color == "2") {
          this.posterImg = this.form_share.images2[1];
        } else if (this.form_share.color == "3") {
          this.posterImg = this.form_share.images2[2];
        } else if (this.form_share.color == "4") {
          this.posterImg = this.form_share.images2[3];
        } else if (this.form_share.color == "5") {
          this.posterImg = this.form_share.images2[4];
        }
        this.qrcode_work1();
      }

      this.share_img = this.posterImg;
    },

    ChangeShareColor() {
      console.log("更换海报颜色");
      console.log(this.form_share.color);

      if (this.form_share.type == "1") {
        if (this.form_share.color == "1") {
          this.posterImg = this.form_share.images1[0];
        } else if (this.form_share.color == "2") {
          this.posterImg = this.form_share.images1[1];
        } else if (this.form_share.color == "3") {
          this.posterImg = this.form_share.images1[2];
        } else if (this.form_share.color == "4") {
          this.posterImg = this.form_share.images1[3];
        } else if (this.form_share.color == "5") {
          this.posterImg = this.form_share.images1[4];
        }
      } else if (this.form_share.type == "2") {
        if (this.form_share.color == "1") {
          this.posterImg = this.form_share.images2[0];
        } else if (this.form_share.color == "2") {
          this.posterImg = this.form_share.images2[1];
        } else if (this.form_share.color == "3") {
          this.posterImg = this.form_share.images2[2];
        } else if (this.form_share.color == "4") {
          this.posterImg = this.form_share.images2[3];
        } else if (this.form_share.color == "5") {
          this.posterImg = this.form_share.images2[4];
        }
      }

      this.share_img = this.posterImg;
    },
    qrcode() {
      document.getElementById("qrcodeImg").innerHTML = "";

      new QRCode("qrcodeImg", {
        width: 150,
        height: 150,
        text:
          "https://steam.fun/scratch/h5player.html?work_type=2&work_id=" +
          this.workinfo.id +
          "&subject_code=2" + `&stuTchPlanIdTest=${this.stuTchPlanInfo.id}&schoolIdTest=${this.stuTchPlanInfo.educational_institution_id}`, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });

      this.dialogVisible = true;
    },
    qrcode_work() {
      document.getElementById("qrcodeWorkImg").innerHTML = "";
      new QRCode("qrcodeWorkImg", {
        width: 365,
        height: 365,
        text:
          "https://steam.fun/scratch/h5player.html?work_type=2&work_id=" +
          this.form_share.work_id +
          "&subject_code=2" + `&stuTchPlanIdTest=${this.stuTchPlanInfo.id}&schoolIdTest=${this.stuTchPlanInfo.educational_institution_id}`, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });
    },

    qrcode_work1() {
      document.getElementById("qrcodeWorkImg1").innerHTML = "";
      new QRCode("qrcodeWorkImg1", {
        width: 240,
        height: 240,
        text:
          "https://steam.fun/scratch/h5player.html?work_type=2&work_id=" +
          this.form_share.work_id +
          "&subject_code=2" + `&stuTchPlanIdTest=${this.stuTchPlanInfo.id}&schoolIdTest=${this.stuTchPlanInfo.educational_institution_id}`, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });
    },

    //海报
    CreatBill(cmd) {
      if (cmd === "1") {
        console.log("生成海报");
        this.dialogVisible2 = true;
        this.form_share.cover = this.stuTchPlanInfo.classWorkInfo.covers;
        this.form_share.work_id = this.stuTchPlanInfo.classWorkInfo.id;
        this.form_share.title = this.stuTchPlanInfo.classWorkInfo.title;
        // this.form_share.name = this.stuTchPlanInfo.classWorkInfo.title;
        this.form_share.name = this.$store.state.user.userInfo.stuUserInfo.realName;

        this.form_share.star_num = this.stuTchPlanInfo.classWorkInfo.markpoint;
      } else {
        console.log("生成海报");
        this.dialogVisible2 = true;
        this.form_share.cover = this.stuTchPlanInfo.homeWorkInfo.covers;
        this.form_share.work_id = this.stuTchPlanInfo.homeWorkInfo.id;
        this.form_share.title = this.stuTchPlanInfo.homeWorkInfo.title;
        // this.form_share.name = this.stuTchPlanInfo.homeWorkInfo.title;
        this.form_share.name = this.$store.state.user.userInfo.stuUserInfo.realName;

        this.form_share.star_num = this.stuTchPlanInfo.homeWorkInfo.markpoint;
      }

      if (this.form_share.type == "1") {
        if (this.form_share.color == "1") {
          this.posterImg = this.form_share.images1[0];
        } else if (this.form_share.color == "2") {
          this.posterImg = this.form_share.images1[1];
        } else if (this.form_share.color == "3") {
          this.posterImg = this.form_share.images1[2];
        } else if (this.form_share.color == "4") {
          this.posterImg = this.form_share.images1[3];
        } else if (this.form_share.color == "5") {
          this.posterImg = this.form_share.images1[4];
        }
        this.qrcode_work();
      } else if (this.form_share.type == "2") {
        if (this.form_share.color == "1") {
          this.posterImg = this.form_share.images2[0];
        } else if (this.form_share.color == "2") {
          this.posterImg = this.form_share.images2[1];
        } else if (this.form_share.color == "3") {
          this.posterImg = this.form_share.images2[2];
        } else if (this.form_share.color == "4") {
          this.posterImg = this.form_share.images2[3];
        } else if (this.form_share.color == "5") {
          this.posterImg = this.form_share.images2[4];
        }
        this.qrcode_work1();
      }

      this.share_img = this.posterImg;
    },

    DownloadImage() {
      console.log("下载分享海报");
      console.log(this.posterImg);

      // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
      if (window.navigator.msSaveOrOpenBlob) {
        const bstr = atob(this.posterImg.split(",")[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        const blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, "chart-download" + "." + "png");
      } else {
        // 这里就按照chrome等新版浏览器来处理
        const a = document.createElement("a");
        a.href = this.posterImg;
        a.setAttribute("download", "chart-download");
        a.click();
      }
    },

    //学生讲义
    LookNote() {
      // 获取当前时间
      const currentTime = moment();

      // 要比较的时间
      const targetTime = moment(
        this.stuTchPlanInfo.techPlanInfo.end_class_date
      );

      // 使用isBefore()方法判断目标时间是否早于当前时间
      if (targetTime.isBefore(currentTime)) {
        console.log("目标时间早于当前时间");
      } else {
        console.log("目标时间晚于或等于当前时间");
        this.$message.info("学生讲义将在课程结束后，自动解锁!");
        return;
      }

      console.log(this.stuInfo.lessionInfo);
      if (this.LessonInfoFor.educational_institution_id === null) {
        this.stu_note_url = this.LessonInfoFor.stu_note_url;
        this.dialogVisible1 = true;
      } else {
        let stu_note_url1 = [];
        stu_note_url1 = JSON.parse(this.LessonInfoFor.stu_note_url);
        stu_note_url1.map((item) => {
          console.log(item.url);
          this.stu_note_url = item.url;
          this.dialogVisible1 = true;
        });
      }
    },
    ReloadData() {
      this.isReloadData = false;
      this.$nextTick(() => {
        this.isReloadData = true;
      });
    },
    //签到
    signIn() {
      this.$confirm("确定要上课签到吗?签到后就可以开始创作啦!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        stuSignInForClass({
          stu_tch_plan_id: this.stuInfo1.id,
        }).then((res) => {
          console.log(res);
          this.$message.success("签到成功");
          this.isShow = false;
          this.isShow1 = true;
          this.stuTchPlanInfo.sign_state = 1;
          console.log(this.stuTchPlanInfo.sign_state);
        });
      });
    },
    //上课创作
    CreateWork(plan_id, operate) {
      console.log("上课创作");
      console.log(plan_id);
      console.log(operate);

      console.log("LessonInfoFor");
      console.log(this.LessonInfoFor);

      if (this.stuTchPlanInfo.subject_id == "1") {
        if (operate == "1") {
          console.log("重新挑战-课堂模板");
          if (this.stuInfo.class_work_url) {
            window.location.href =
              "/jrcode/course.html?mode=edit&role=stu&type=4&filepath=" +
              this.stuInfo.class_work_url +
              "&plan_id=" +
              plan_id +
              "&operate=" +
              operate;
          } else {
            if (this.LessonInfoFor.educational_institution_id !== null) {
              console.log("校区课程");
              window.location.href =
                "/jrcode/course.html?mode=edit&role=stu&type=4&filepath=" +
                "https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/jrcode/project.sjr" +
                "&plan_id=" +
                plan_id +
                "&operate=" +
                operate;
            } else {
              console.log("平台");
              window.location.href =
                "/jrcode/course.html?mode=edit&role=stu&type=4&filepath=" +
                this.LessonInfoFor.teach_template_url +
                "&plan_id=" +
                plan_id +
                "&operate=" +
                operate;
            }
          }
        } else if (operate == "2") {
          console.log("继续挑战-课堂模板");
          window.location.href =
            "/jrcode/course.html?mode=edit&role=stu&type=4&filepath=" +
            this.stuTchPlanInfo.classWorkInfo.work_url +
            "&plan_id=" +
            plan_id +
            "&operate=" +
            operate;
        } else if (operate == "3") {
          console.log("重新挑战-课后作业");
          if (this.stuInfo.homework_work_url) {
            window.location.href =
              "/jrcode/course.html?mode=edit&role=stu&type=4&filepath=" +
              this.stuInfo.homework_work_url +
              "&plan_id=" +
              plan_id +
              "&operate=" +
              operate;
          } else {
            if (this.LessonInfoFor.educational_institution_id !== null) {
              window.location.href =
                "/jrcode/course.html?mode=edit&role=stu&type=4&filepath=" +
                "https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/jrcode/project.sjr" +
                "&plan_id=" +
                plan_id +
                "&operate=" +
                operate;
            } else {
              window.location.href =
                "/jrcode/course.html?mode=edit&role=stu&type=4&filepath=" +
                this.LessonInfoFor.home_template_url +
                "&plan_id=" +
                plan_id +
                "&operate=" +
                operate;
            }
          }
        } else if (operate == "4") {
          console.log("继续挑战-课后作业");
          window.location.href =
            "/jrcode/course.html?mode=edit&role=stu&type=4&filepath=" +
            this.stuTchPlanInfo.homeWorkInfo.work_url +
            "&plan_id=" +
            plan_id +
            "&operate=" +
            operate;
        }
      } else if (this.stuTchPlanInfo.subject_id == "2") {
        window.location.href =
          "/scratch/course.html?plan_id=" + plan_id + "&operate=" + operate;
      } else if (this.stuTchPlanInfo.subject_id == "3") {
        console.log("Python课程");

        console.log(this.stuTchPlanInfo); //学生讲次信息
        console.log(this.LessonInfoFor);

        if (this.LessonInfoFor.educational_institution_id !== null) {
          console.log("校区自定义课程");

          if (operate == "1") {
            console.log("学生首次创作");
            console.log(this.stuInfo);

            if (this.stuInfo.class_work_url !== null) {
              console.log("老师修改了模板");

              sessionStorage.setItem(
                "py_exam_code",
                this.stuInfo.class_work_url
              );

              this.$router.push({
                name: "python_course_v2",
                query: {
                  type: "4",
                  title: this.stuInfo.lessionInfo.title,
                  plan_id: plan_id,
                  operate: operate,
                },
                params: {
                  lessionInfo: this.LessonInfoFor,
                  stuTchPlanInfo: this.stuTchPlanInfo,
                },
              });
            } else {
              console.log("老师没有修改模板");

              console.log(this.stuTchPlanInfo);

              if (this.LessonInfoFor.teach_template_url !== null) {
                console.log("校区上传了模版");

                console.log(this.LessonInfoFor);

                this.ReadPyCode(
                  this.LessonInfoFor.teach_template_url,
                  (res) => {
                    console.log("校区自定义代码正确代码");
                    console.log(res);
                    sessionStorage.setItem("py_exam_code", res);

                    //写入成功后再做路由跳转
                    this.$router.push({
                      name: "python_course_v2",
                      query: {
                        type: "9",
                        title: this.stuInfo.lessionInfo.title,
                        plan_id: plan_id,
                        operate: operate,
                      },
                      params: {
                        lessionInfo: this.LessonInfoFor,
                        stuTchPlanInfo: this.stuTchPlanInfo,
                      },
                    });
                  }
                );
              } else {
                console.log("校区没有上传模版");
                this.$router.push({
                  name: "python_course_v2",
                  query: {
                    type: "8",
                    title: this.stuInfo.lessionInfo.title,
                    plan_id: plan_id,
                    operate: operate,
                  },
                  params: {
                    lessionInfo: this.LessonInfoFor,
                    stuTchPlanInfo: this.stuTchPlanInfo,
                  },
                });
              }
            }
          } else if (operate == "2") {
            console.log("学生继续挑战");

            sessionStorage.setItem(
              "py_teach_code",
              this.stuTchPlanInfo.classWorkInfo.work_url
            );

            this.$router.push({
              name: "python_course_v2",
              query: {
                type: "5",
                title: this.stuTchPlanInfo.classWorkInfo.title,
                plan_id: plan_id,
                operate: operate,
              },
              params: {
                lessionInfo: this.LessonInfoFor,
                stuTchPlanInfo: this.stuTchPlanInfo,
              },
            });
          } else if (operate == "3") {
            console.log("课后挑战");

            if (this.stuInfo.homework_work_url !== null) {
              console.log("老师修改了作业模板");

              sessionStorage.setItem(
                "py_teach_code",
                this.stuInfo.homework_work_url
              );

              this.$router.push({
                name: "python_course_v2",
                query: {
                  type: "6",
                  title: this.stuInfo.lessionInfo.title,
                  plan_id: plan_id,
                  operate: operate,
                },
                params: {
                  lessionInfo: this.LessonInfoFor,
                  stuTchPlanInfo: this.stuTchPlanInfo,
                },
              });
            } else {
              console.log("老师没有修改作业模板");
              console.log(this.stuTchPlanInfo);

              if (this.LessonInfoFor.home_template_url !== null) {
                console.log("校区上传了课后挑战模版");

                this.ReadPyCode(this.LessonInfoFor.home_template_url, (res) => {
                  console.log("校区自定义代码正确代码");
                  console.log(res);
                  sessionStorage.setItem("py_exam_code_10", res);

                  //写入成功后再做路由跳转
                  this.$router.push({
                    name: "python_course_v2",
                    query: {
                      type: "10",
                      title: this.stuInfo.lessionInfo.title,
                      plan_id: plan_id,
                      operate: operate,
                    },
                    params: {
                      lessionInfo: this.LessonInfoFor,
                      stuTchPlanInfo: this.stuTchPlanInfo,
                    },
                  });
                });
              } else {
                console.log("校区没有上传课后挑战模版");
                this.$router.push({
                  name: "python_course_v2",
                  query: {
                    type: "8",
                    title: this.stuInfo.lessionInfo.title,
                    plan_id: plan_id,
                    operate: operate,
                  },
                  params: {
                    lessionInfo: this.LessonInfoFor,
                    stuTchPlanInfo: this.stuTchPlanInfo,
                  },
                });
              }
            }
          } else if (operate == "4") {
            console.log("校区自定义课程，学生完成了课后作业，继续挑战");

            sessionStorage.setItem(
              "py_teach_code",
              this.stuTchPlanInfo.homeWorkInfo.work_url
            );

            this.$router.push({
              name: "python_course_v2",
              query: {
                type: "7",
                title: this.stuTchPlanInfo.homeWorkInfo.title,
                plan_id: plan_id,
                operate: operate,
              },
              params: {
                lessionInfo: this.LessonInfoFor,
                stuTchPlanInfo: this.stuTchPlanInfo,
              },
            });
          }
        } else {
          console.log("平台");

          console.log("current_py_version");
          console.log(localStorage.getItem("current_py_version"));

          if (localStorage.getItem("current_py_version") == "v2") {
            this.$router.push({
              name: "python_course_v2",
              query: {
                type: "2",
                title: this.stuInfo.lessionInfo.title,
                plan_id: plan_id,
                operate: operate,
              },
              params: {
                lessionInfo: this.LessonInfoFor,
                stuTchPlanInfo: this.stuTchPlanInfo,
              },
            });
          } else if (localStorage.getItem("current_py_version") == "v1") {
            this.$router.push({
              name: "python_course",
              query: {
                type: "2",
                title: this.stuInfo.lessionInfo.title,
                plan_id: plan_id,
                operate: operate,
              },
              params: {
                lessionInfo: this.LessonInfoFor,
                stuTchPlanInfo: this.stuTchPlanInfo,
              },
            });
          } else {
            this.$router.push({
              name: "python_course_v2",
              query: {
                type: "2",
                title: this.stuInfo.lessionInfo.title,
                plan_id: plan_id,
                operate: operate,
              },
              params: {
                lessionInfo: this.LessonInfoFor,
                stuTchPlanInfo: this.stuTchPlanInfo,
              },
            });

            localStorage.setItem("current_py_version", "v2");
          }
        }
      }
      this.stuGetTchWorkListByStuTchPlanId();
    },
  },
};
</script>

<style lang="scss" scoped>
.eval-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .iframe-box {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px 20px 0 20px;
  }
  ul.pagination {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    // height: 100px;
    padding: 15px 20px 5px;
    background-color: #fff;
    border-top: 1px solid #ccc;
    li {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 25px;
      height: 25px;
      margin-right: 10px;
      margin-bottom: 10px;
      font-size: 12px;
      color: #1878ff;
      border: 1px solid #1878ff;
      border-radius: 5px;
      cursor: pointer;
      transition: all 0.15s;
      &.active {
        background-color: #1878ff;
        color: #fff;
      }
    }
  }
  // li {
  //   padding: 25px 20px 40px;
  //   border-bottom: 4px solid rgba(178, 210, 238, 0.3);
  //   &:last-child {
  //     border: none;
  //   }
  //   .eval-top {
  //     display: flex;
  //     align-items: center;
  //     margin-bottom: 15px;
  //     strong {
  //       font-size: 18px;
  //       margin-right: 30px;
  //     }
  //     span {
  //       font-size: 14px;
  //       color: #999;
  //     }
  //   }
  //   .eval-title {
  //     display: flex;
  //     align-items: center;
  //     margin-bottom: 5px;
  //     font-size: 14px;
  //     font-weight: bold;
  //     img {
  //       width: 20px;
  //       margin-right: 5px;
  //     }
  //   }
  //   .eval-content {
  //     padding: 10px;
  //     border-radius: 10px;
  //     border: 1px dashed rgb(209, 189, 107);
  //     background: #fdf5da;
  //     p {
  //       display: -webkit-box;
  //       -webkit-line-clamp: 3;
  //       -webkit-box-orient: vertical;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //       white-space: pre-wrap;
  //     }
  //   }
  // }
}
.container {
  box-sizing: border-box;
  min-width: 1200px;
  height: calc(100vh - 60px);
  padding: 30px 20px;
  background-color: #f8f9fb;
  min-height: 700px;

  .school-body {
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    // background: white;
    // background: firebrick;
    background: url("../../../../assets/image/stuUI/stuDetailBg@2x.png") left
      top / 100% 100% no-repeat;
    border-radius: 20px;
    padding-top: 25px;
    padding-left: 40px;
    padding-right: 20%;
    padding-bottom: 20px;
    .el-card {
      overflow: initial;
    }
    .classwrapper {
      border-radius: 5px;
      .classheader {
        margin-top: 15px;
        margin-left: 15px;
      }

      .classlist {
        padding-left: 15px;
        padding-right: 15px;
        padding-bottom: 15px;

        .classlist_wrapper {
          .classlist-imgwrapper {
            width: 80%;

            .classimg_wrapper_img {
              width: 100%;
              border-radius: 5px;
              margin-bottom: 10%;
              margin-top: 10%;
            }
          }

          .classlist-content {
            flex: 1;
            display: flex;
            flex-flow: column;
            margin-top: 2%;

            .classlist-content-title {
              flex: 1;

              font-weight: 500;

              .coursetitle {
                padding-right: 10px;
                font-weight: bold;
                font-size: 18px;
              }
            }

            .classlist-content-desc {
              font-size: 14px;
              flex: 1;
              line-height: 25px;

              margin-top: 15px;

              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;

              .content-desc {
                padding-right: 20px;
              }
            }

            .classlist-content-date {
              flex: 1;

              line-height: 40px;
            }
          }

          .classlist-btn {
            margin-top: 15%;
            text-align: center;
          }
        }
      }

      .classimg_wrapper {
        .classimg_wrapper_img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
      }

      .classdesc_wrapper {
        padding: 15px;
        height: 100px;

        .classdesc_title {
          padding-bottom: 10px;
        }
      }
    }
  }
}

.main {
  margin-top: 30px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  padding: 15px;
  overflow: hidden;

  box-shadow: 0px 0px 10px 10px #ccc;
}

.topTxt {
  margin-top: 30px;
}

.text_title {
  font-weight: bold;
  font-size: 18px;
}

.margin_top {
  margin-top: 15px;
  margin-left: 0px;
  line-height: 20px;
}

.stuWorks {
  width: 100%;

  border-radius: 5px;
}

.image {
  width: 257px;
  height: 193px;
  border-radius: 5px;
}

.topSpacing {
  margin-top: 10px;
}

.text_btn {
  cursor: pointer;
  color: rgba(42, 130, 228, 1);
  font-size: 14px;
  font-weight: bold;
}

.operation {
  position: fixed;
  right: 30px;
  top: 11vh;
  width: 35%;
  height: 110px;
  // background-color: firebrick;
  .operation-box {
    display: flex;
    align-items: flex-end;
    // height: 80px;
    .operation-item {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      margin-right: 40px;
      cursor: pointer;
      img {
        width: 55px;
      }
      span {
        padding-top: 5px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
      // &.poster {
      //   img {
      //     width: 65px;
      //     height: 86px;
      //   }
      //   span {
      //     padding-left: 12px;
      //   }
      // }
      // &.handouts {
      //   img {
      //     width: 101px;
      //     height: 104px;
      //   }
      //   span {
      //     transform: translateY(-9px);
      //   }
      // }
      // &.manual {
      //   img {
      //     width: 103px;
      //     height: 102px;
      //   }
      //   span {
      //     transform: translateY(-8px);
      //   }
      // }
      // &.video {
      //   margin-right: 0;
      //   img {
      //     width: 80px;
      //     height: 80px;
      //   }
      //   span {
      //     padding-left: 8px;
      //     transform: translateY(3px);
      //   }
      // }
    }
  }
}
</style>
